import React from 'react';
import Modal from 'contexts/ModalContext/Modal';
import styled from 'styled-components';

const qnas = [
  {
    question: '본격적인 반복학습을 통해 케이스 연습을 시작하고 싶다면?',
    answer: '케이스 문제',
    href: 'https://bigstepedu.com/case/quizzes',
  },
  {
    question: '산업 분석 및 오프라인 Mock 인터뷰를 체험해보고 싶다면?',
    answer: '전략컨설팅 인터뷰 Master Class [실습편]',
    href: 'https://bigstepedu.com/mentoring/program_about?field=consulting',
  },
  {
    question: 'MBB 합격자의 케이스 스크립트를 보고 나의 접근법과 비교해보고 싶다면?',
    answer: '케이스 노트',
    href: 'https://bigstepedu.com/case/introduction',
  },
  {
    question: '인터뷰가 얼마 남지 않아 본격적으로 Mock 인터뷰가 필요하다면?',
    answer: '커리어스텝 1:1 멘토링',
    href: 'https://bigstepedu.com/mentoring/mentor_list',
  },
];

function InterviewMasterClassBasicSelfStudyModal() {
  return (
    <Modal title='수강 후 학습방법' maxWidth={520}>
      <StyledContainer>
        <p>강의 수강 후 커리어스텝을 통한 추천 학습방법</p>

        <ul>
          {qnas.map((qna) => (
            <li>
              <QnA key={qna.question} question={qna.question} answer={qna.answer} href={qna.href} />
            </li>
          ))}
        </ul>
      </StyledContainer>
    </Modal>
  );
}

interface QnAProps {
  question: string;
  answer: string;
  href: string;
}

function QnA({ question, answer, href }: QnAProps) {
  return (
    <article className='qna'>
      <div className='question'>{question}</div>
      <a href={href} className='answer' target='_blank' rel='noreferrer'>
        {answer}
      </a>
    </article>
  );
}

const StyledContainer = styled.div`
  > p {
    font-weight: 700;
    font-size: 15px;
    color: black;
    text-align: center;
    margin-bottom: 20px;
  }

  > ul {
    list-style: none;
    padding-left: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    row-gap: 16px;

    > li > .qna {
      display: grid;
      grid-auto-flow: row;
      grid-template-rows: repeat(2, 45px);
      font-size: 15px;
      font-weight: 500;

      > * {
        place-content: center;
        text-align: center;
      }

      > .question {
        background-color: #f7f7f7;
        border: 1px solid #e8e8e8;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }

      > .answer {
        color: #3cac40;
        background-color: white;
        border: 1px solid #e8e8e8;
        border-top: none;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
      }
    }
  }
`;

export default InterviewMasterClassBasicSelfStudyModal;
